
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcToggleButtonThreeState as ObcToggleButtonThreeStateElement} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-three-state/toggle-button-three-state.js';
 import {ObcToggleButtonThreeStateChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-three-state/toggle-button-three-state.js';
 export type {ObcToggleButtonThreeStateChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-three-state/toggle-button-three-state.js';
 

 
 export const ObcToggleButtonThreeState = createComponent({
   react: React,
   tagName: 'obc-toggle-button-three-state',
   elementClass: ObcToggleButtonThreeStateElement,
   events: {
     
     onChange: 'change' as EventName<ObcToggleButtonThreeStateChangeEvent>,
   }
  });
 
 